// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"529":"03e18103","794":"91e7d173"}[chunkId] + ".js";
};